import { useState } from "react";

// Mobile-first form primitives shared across all entry flows.

export function Field({ label, children, hint }) {
  return (
    <label className="block">
      <span className="mb-1 block text-sm font-medium text-slate-700">{label}</span>
      {children}
      {hint && <span className="mt-1 block text-xs text-slate-400">{hint}</span>}
    </label>
  );
}

export const inputCls =
  "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-base focus:border-navy-600 focus:outline-none";

export function Segmented({ options, value, onChange }) {
  return (
    <div className="grid w-full grid-flow-col rounded-xl bg-slate-100 p-1">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={`rounded-lg px-3 py-2 text-sm font-semibold transition ${
            value === o.value ? "bg-white text-navy-700 shadow-sm" : "text-slate-500"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

// Select with an "Other…" escape hatch that opens a free-text input and
// remembers the typed value in the options for the rest of the session
// (the server persists it for next time).
export function SelectWithOther({ value, onChange, options, placeholder = "Select…" }) {
  const [other, setOther] = useState(false);
  const known = options.includes(value);

  if (other || (value && !known)) {
    return (
      <div className="flex gap-2">
        <input
          autoFocus
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Type your own…"
          className={inputCls}
        />
        <button
          type="button"
          className="shrink-0 rounded-xl border border-slate-300 px-3 text-sm text-slate-500"
          onClick={() => {
            setOther(false);
            onChange("");
          }}
        >
          List
        </button>
      </div>
    );
  }
  return (
    <select
      value={value || ""}
      onChange={(e) => {
        if (e.target.value === "__other__") {
          setOther(true);
          onChange("");
        } else onChange(e.target.value);
      }}
      className={inputCls}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
      <option value="__other__">Other…</option>
    </select>
  );
}

export function SaveButton({ busy, children }) {
  return (
    <button
      type="submit"
      disabled={busy}
      className="w-full rounded-xl bg-navy-700 py-3.5 text-base font-semibold text-white disabled:opacity-50"
    >
      {busy ? "Saving…" : children}
    </button>
  );
}
